import {
  object,
  string
} from "yup";

import "./schemas";

const authorisedMaintenanceSchema = object({
  atwPtwNumber: string()
    .trim()
    .required()
    .label("AtwPtwNumber"),
  undertakenBy: string()
    .trim()
    .required()
    .label("UndertakenBy")
});

export default authorisedMaintenanceSchema;
